import React, { useEffect, useState } from 'react'
import { pagesText } from '../../../constants/english'
import { formatNumber, getCurrencySymbol } from '../../../helpers/helpers'
import { useDispatch, useSelector } from 'react-redux'
import { getRequest } from '../../../helpers/request'
import { appApi } from '../../../utils/endpoints/appApi'
import { onGetAdditionalDocuments } from '../../../config/redux/slice/appSlice'
import { convertDateTime } from '../../../utils/lib'

export default function CertificateDetailsComponent({certificateObject}) {
  const dispatch = useDispatch()
  const [currency, setCurrency] = useState('')
  const [isOverflow, setIsoverflow] = useState(false)

  const {
        currencies,
        // additionalDocs
    } = useSelector((state) => state.app)

  const {
        token,
    } = useSelector((state) => state.authData)

  useEffect(()=>{
    // let value = getCurrencySymbol(currencies, certificateObject.CURRENCY)
    // setCurrency(value)
    // getAdditionalDocs()
    if(currencies.length > 0){
      let value = getCurrencySymbol(currencies, certificateObject.CURRENCY)
      setCurrency(value)
    }
    monitorTextOverflow()
  }, [])

  useEffect(()=>{
    monitorTextOverflow()
  }, [isOverflow])

    function setAnchorTagText(){
      let element = document.getElementById('line-clamp')
      let readMore = document.getElementById('read-more')
      if(isOverflow){
        element.classList.remove('line-clamp')
        readMore.innerHTML = 'Read Less'
      } else{
        element.classList.add('line-clamp')
        readMore.innerHTML = 'Read More'
      }
      setIsoverflow(!isOverflow)
    }

    function monitorTextOverflow(){
      let element = document.getElementById('line-clamp')
      let readMore = document.getElementById('read-more')
      if (element.offsetWidth < element.scrollWidth) {
        
            readMore.style.display = 'block'
        }
    }

    // const getAdditionalDocs = async () =>{
    //   const res = await getRequest(
    //     token,
    //     `${appApi.getAdditionalDocuments(certificateObject.ID)}`,
    //     {},
    //     dispatch,
    //     "",
    //     onGetAdditionalDocuments,
    //     ""
    //   )
    // }
  return (
    <div className="row details-child">
                  <div className='col-12'>

                    <div className="card card-default">
                      <div className="card-body py-0 px-0">
                        <table className="table table-borderless table-thead-border table-striped">
                          <thead>
                          </thead>
                          <tbody>
                            {/* <tr>
                              <td className="py-2 px-2 text-dark font-weight-bold">Issuer</td>
                              <td className="py-2 px-2 text-right text-dark">{certificateObject?.CERTIFICATE_ISSUER}</td>
                            </tr> */}
                            <tr>
                              <td className="py-2 px-2 text-dark font-weight-bold">Reference ID</td>
                              <td className="py-2 px-2 text-right text-dark">{certificateObject?.CERTIFICATE_NUMBER}</td>
                            </tr>
                            <tr>
                              <td className="py-2 px-2 text-dark font-weight-bold">Certificate Number</td>
                              <td className="py-2 px-2 text-right text-dark">{certificateObject?.CERTIFICATE_NUMBER_TWO}</td>
                            </tr>
                            <tr>
                              <td className="py-2 px-2 text-dark font-weight-bold">Issue Date</td>
                              <td className="py-2 px-2 text-right text-dark">{certificateObject?.CERTIFICATE_DATE}</td>
                            </tr>
                            <tr>
                              <td className="py-2 px-2 text-dark font-weight-bold">Expiry Date</td>
                              <td className="py-2 px-2 text-right text-dark">{certificateObject?.EXPIRY_DATE}</td>
                            </tr>
                            <tr>
                              <td className="py-2 px-2 text-dark font-weight-bold">Effective Date</td>
                              <td className="py-2 px-2 text-right text-dark">{certificateObject?.EFFECTIVE_DATE}</td>
                            </tr>
                            <tr>
                              <td className="py-2 px-2 text-dark font-weight-bold">Currency</td>
                              <td className="py-2 px-2 text-right text-dark">{certificateObject?.CURRENCY}</td>
                            </tr>
                            <tr>
                              <td className="py-2 px-2 text-dark font-weight-bold">Total Amount</td>
                              <td className="py-2 px-2 text-right text-dark">{currency}{Number(certificateObject?.AMOUNT_ON_CERTIFICATE)?.toLocaleString(
                                 'en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                    }
                              )}</td>
                            </tr>
                            <tr>
                              <td className="py-2 px-2 text-dark font-weight-bold">Amount Requested</td>
                              <td className="py-2 px-2 text-right text-dark">{currency}{Number(certificateObject?.AMOUNT_REQUEST)?.toLocaleString(
                                 'en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                    }
                              )}</td>
                            </tr>
                             <tr>
                              <td className="py-2 px-2 text-dark font-weight-bold">Approved Amount</td>
                               {certificateObject?.APPROVED_AMOUNT_FOR_DISTURBED ? 
                              <td className="py-2 px-2 text-right text-dark">{currency}{Number(certificateObject?.APPROVED_AMOUNT_FOR_DISTURBED)?.toLocaleString(
                                'en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                    }
                              )}</td> : <td className="py-2 px-2 text-right text-dark">N/A</td>}
                              {/* <td className="py-2 px-2 text-right text-dark">{currency}{formatNumber(certificateObject?.APPROVED_AMOUNT_FOR_DISTURBED)}</td> */}
                            </tr>
                            <tr>
                              <td className="py-2 px-2 text-dark font-weight-bold">WithHolding Tax (WHT) Rate</td>
                              <td className="py-2 px-2 text-right text-dark">{certificateObject?.WHT_RATE_PERCENTAGE ? `${certificateObject?.WHT_RATE_PERCENTAGE}%` : 'N/A'}</td>
                            </tr>
                            <tr>
                              <td className="py-2 px-2 text-dark font-weight-bold">Amount Available</td>
                              {certificateObject?.AMOUNT_AVAILABLE ? 
                              <td className="py-2 px-2 text-right text-dark">{currency}{Number(certificateObject?.AMOUNT_AVAILABLE)?.toLocaleString(
                                'en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                    }
                              )}</td> : <td className="py-2 px-2 text-right text-dark">N/A</td>}
                            </tr>
                            <tr>
                              <td className="py-2 px-2 text-dark font-weight-bold">Balance</td>
                              {certificateObject?.AMOUNT_AVAILABLE ? 
                              <td className="py-2 px-2 text-right text-dark">{currency}{Number(certificateObject?.CERTIFICATE_BALANCE)?.toLocaleString(
                                'en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                    }
                              )}</td> : <td className="py-2 px-2 text-right text-dark">N/A</td>}
                            </tr>
                            <tr>
                              <td className="py-2 px-2 text-dark font-weight-bold">Swift Number</td>
                              <td className="py-2 px-2 text-right text-dark">{certificateObject?.SWIFT_NUMBER ?? 'N/A'}</td>
                            </tr>
                            <tr>
                              <td className="py-2 px-2 text-dark font-weight-bold">Status</td>
                              <td className={`py-2 px-2 text-right`}>
                                  <div className={`py-2 px-2 text-right badge badge-pill text-white text-capitalize
                                    ${certificateObject?.CERTIFICATE_STATUS == 'pending' ? 'badge-warning' 
                                    : certificateObject?.CERTIFICATE_STATUS == 'approved' ? 'badge-info' 
                                    : certificateObject?.CERTIFICATE_STATUS == 'disapproved' ? 'badge-danger' 
                                    : certificateObject?.CERTIFICATE_STATUS == 'confirmed' ? 'badge-orange' 
                                    : certificateObject?.CERTIFICATE_STATUS == 'disbursed' ? 'badge-success' :
                                     'badge-danger'}`}>
                                    {certificateObject?.CERTIFICATE_STATUS}
                                  </div>
                              </td>
                            </tr>
                            <tr>
                              <td className="py-2 px-2 text-dark font-weight-bold">Created At</td>
                              <td className="py-2 px-2 text-right text-dark">
                                { certificateObject?.CREATED_AT ?
                                    convertDateTime(certificateObject?.CREATED_AT, pagesText.full_date) :
                                    ''
                                }    
                                    </td>           
                            </tr>
                            <tr>
                              <td className="py-2 px-2 text-dark font-weight-bold">Additional Details</td>
                              <td className="py-2 px-2 text-right text-dark">
                               <div style={{maxHeight: '9rem', overflowY: 'auto'}}>
                                 <p id='line-clamp' className='line-clamp'>{certificateObject?.ADDITIONAL_DETAILS}</p>
                                  <a onClick={setAnchorTagText} id='read-more'>Read More</a>
                               </div>
                                </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                  </div>
                </div>
  )
}
